import { Stack, Text, Title } from '@mantine/core';

export function SectionHeader({
  title,
  description,
}: Readonly<{
  title: string;
  description?: string;
}>) {
  return (
    <Stack gap={0} align="center">
      <Title fz={'h2'} fw={800}>{title}</Title>
      <Text fz={'sm'} c={'var(--text-muted)'} lh={'normal'} mt={8}>{description}</Text>
    </Stack>
  );
}
